/**
 * "My territory" view for admins and HQ managers who also work a territory
 * (in a one-person org, the admin always does). They normally see the whole
 * org; the toggle narrows the map to their own cells and sends
 * X-Northai-Scope: mine so the briefing, route planner and graph answers
 * cover only their territory too. The header can only narrow: the API
 * ignores it for reps, who are already scoped.
 */
import axios from 'axios';

export const SCOPE_HEADER = 'X-Northai-Scope';
export const STORAGE_KEY = 'northai.myTerritoryOnly';
const WIDE_ROLES = new Set(['admin', 'hq_manager']);

export function canUseMyTerritory(role, territoryCount) {
  return WIDE_ROLES.has(role) && territoryCount > 0;
}

export function applyScopeHeader(on) {
  if (on) axios.defaults.headers.common[SCOPE_HEADER] = 'mine';
  else delete axios.defaults.headers.common[SCOPE_HEADER];
}

export function cellsFromTerritories(territories = []) {
  return new Set(territories.flatMap(t => t.h3_cells || []));
}

/** Keep leads whose cell is in `cells`; `cellOf` resolves a lead's H3 cell. */
export function filterToCells(leads, cells, cellOf) {
  if (!cells || cells.size === 0) return leads;
  return leads.filter(lead => {
    const cell = lead.h3_index || (cellOf ? cellOf(lead) : null);
    return cell ? cells.has(cell) : false;
  });
}

export function readStoredToggle() {
  try { return window.localStorage.getItem(STORAGE_KEY) === '1'; } catch { return false; }
}

export function storeToggle(on) {
  try { window.localStorage.setItem(STORAGE_KEY, on ? '1' : '0'); } catch { /* private mode */ }
}
